import $ from "jquery";

// Required if validation
$.validator.addMethod("zipcode", function (value, element, parameters) {
	// If this is an complex object we need to get the full name (example: User.Name.Firstname = User.Name )
	var modelPrefix = element.name.substr(0, element.name.lastIndexOf(".")),
	// Get all elements with this name
	countryElement = modelPrefix ? $("[name='" + modelPrefix + "." + parameters.countryname + "']") : $("[name='" + parameters.countryname + "']"),

	countryElement = countryElement.val();

	if (!value) {
		return true;
	}

	if (countryElement.toLowerCase() !== "se") {
		return true;
	}

	value = value.match(/^(?:[A-zÀ-úÄ-ü]{2})?-?(?:\d{3})\s?\d{2}$/);
	if (value != null) {
		return true;
	}

	return false;
});
$.validator.unobtrusive.adapters.add("zipcode", ["countryname"], function (options) {
	options.rules["zipcode"] = {
		countryname: options.params["countryname"]
	};
	options.messages["zipcode"] = options.message;
});